// Website forms → backend (/api/public/site/*). Firebase rewrites /api/** to the backend, so the
// site calls its own origin. Resolves to the JSON body; rejects with the error code on failure.
export const TOPIC_CODES = ['product', 'pricing', 'support', 'partner', 'other'];

const post = async (path, body) => {
  const res = await fetch(`/api/public/site/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error((data.detail && data.detail.code) || `http_${res.status}`);
  return data;
};

export const submitInquiry = (form, { topics, lang }) => post('inquiry', {
  name: form.name.trim(),
  email: form.email.trim(),
  phone: form.phone.trim(),
  company: form.company.trim(),
  topic: TOPIC_CODES[topics.indexOf(form.pick)] || 'other',
  platforms: form.platforms,
  volume: form.volume,
  message: form.message,
  consent: form.consent,
  lang,
  website: form.website || '',
});

export const subscribeInsights = (email, lang) => post('subscribe', { email: email.trim(), lang });

// Double opt-in links from the emails. Both need a click on the page: mail scanners open links, and a
// bare visit must not confirm or unsubscribe anyone.
export const confirmSubscription = (token) => post('subscribe/confirm', { token });

export const unsubscribeInsights = (token) => post(`unsubscribe?token=${encodeURIComponent(token)}`, {});
